import React, { useState, useEffect } from "react";
import "./NewDownload.scss";
import DownloadServices from "../../services/api/DownloadServices";
import VesselServices from "../../services/api/VesselServices";
import DeviceServices from "../../services/api/DeviceServices";
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useAuthContext } from "../../dataproviders/AuthDataProvider";
import { useDownloadContext } from "../../dataproviders/DownloadDataProvider";
import { Calendar } from '../../utils/widgets/Calendar';

function NewDownload() {
    const mainContext = useMainContext();
    const authContext = useAuthContext();
    const downloadContext = useDownloadContext();
    const [selectedStartDate, setSelectedStartDate] = useState(new Date()); // Initial value for the date
    const [selectedEndDate, setSelectedEndDate] = useState(new Date()); // Initial value for the date

    const [vessels, setVessels] = useState([]);
    const [devices, setDevices] = useState([]);

    const [downloadData, setDownloadData] = useState({
        startdate: '',
        enddate: '',
        freqtype: '',
        vesselid: '',
        deviceid: ''
    });

    const [validationErrors, setValidationErrors] = useState({
        startdate: '',
        enddate: '',
        freqtype: '',
        vesselid: '',
        deviceid: ''
    });

    const [showDropdown, setShowDropdown] = useState({
        freqtype: false,
        vesselid: false,
        deviceid: false
    });

    const [selectedOpt, setSelectedOpt] = useState({
        freqtype: '',
        vesselid: '',
        deviceid: ''
    });

    const [selectedDesc, setSelectedDesc] = useState({
        freqtype: '',
        vesselid: '',
        deviceid: ''
    });

    const toggleDropdownFreqType = () => {
        setShowDropdown((prev) => ({
            ...prev,
            freqtype: !showDropdown.freqtype,
            vesselid: false,
            deviceid: false
        }));
    };

    const toggleDropdownVesselId = () => {
        setShowDropdown((prev) => ({
            ...prev,
            freqtype: false,
            vesselid: !showDropdown.vesselid,
            deviceid: false
        }));
    };

    const toggleDropdownDeviceId = () => {
        setShowDropdown((prev) => ({
            ...prev,
            freqtype: false,
            vesselid: false,
            deviceid: !showDropdown.deviceid
        }));
    };

    const handleOptionClick = (option, name, type) => {
        if (type === 'freqtype') {
            setDownloadData((prev) => ({
                ...prev,
                freqtype: option,
            }));

            setValidationErrors((prev) => ({
                ...prev,
                freqtype: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                freqtype: option
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                freqtype: name
            }));

            setShowDropdown((prev) => ({
                ...prev,
                freqtype: false
            }));
        }
        else if (type === 'vesselid') {
            setDownloadData((prev) => ({
                ...prev,
                vesselid: option,
            }));

            setValidationErrors((prev) => ({
                ...prev,
                vesselid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                vesselid: option
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                vesselid: name
            }));

            setShowDropdown((prev) => ({
                ...prev,
                vesselid: false
            }));
        }
        else { //deviceid
            setDownloadData((prev) => ({
                ...prev,
                deviceid: option,
            }));

            setValidationErrors((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                deviceid: option
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                deviceid: name
            }));

            setShowDropdown((prev) => ({
                ...prev,
                deviceid: false
            }));
        }
    };

    const isOptionSelected = (option, type) => {
        if (type === 'freqtype') {
            return option === selectedOpt.freqtype ? 'selected' : '';
        }
        else if (type === 'vesselid') {
            return option === selectedOpt.vesselid ? 'selected' : '';
        }
        else { //deviceid
            return option === selectedOpt.deviceid ? 'selected' : '';
        }
    };

    const renderSelectTag = (option, type) => {
        if (type === 'freqtype') {
            if (option === selectedOpt.freqtype) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }
        else if (type === 'vesselid') {
            if (option === selectedOpt.vesselid) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }
        else { //deviceid
            if (option === selectedOpt.deviceid) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }

        return (
            <span className="select-tag">
            </span>
        );
    };

    const handleSaveDownload = (e) => {

        //clear dropdown
        setShowDropdown({
            freqtype: false,
            vesselid: false,
            deviceid: false
        });

        const errors = {};

        if (!downloadData.freqtype) {
            errors.freqtype = 'Frequency Type is required.';
        }

        if (!downloadData.vesselid) {
            errors.vesselid = 'Vessel is required.';
        }

        if (!downloadData.deviceid) {
            errors.deviceid = 'Device is required.';
        }

        if (!downloadData.startdate) {
            errors.startdate = 'Start Date is required.';
        }

        if (!downloadData.enddate) {
            errors.enddate = 'End Date is required.';
        }

        if (downloadData.startdate &&
            downloadData.enddate &&
            new Date(downloadData.startdate) > new Date(downloadData.enddate)) {
            errors.enddate = 'End Date cannot be less than Start Date.';
        }

        setValidationErrors(errors);

        if (Object.keys(errors).length === 0) {
            downloadData.freqtype = parseInt(downloadData.freqtype);
            //Send data to server
            saveDownload(downloadData);
        }
    };

    const saveDownload = async (newdownload) => {
        const cancelButton = document.getElementById("btnSaveDownload");

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            const result = await DownloadServices.AddDownload(newdownload);

            if (!!result) {
                if (typeof result.data.errormessage === 'undefined' || result.data.errormessage === null || result.data.errormessage === "") {
                    handleError('Success', 'Download has been successfully saved.');
                    downloadContext.SetRefreshFlag(true);
                }
                else {
                    handleError('Error', `Download has failed to save due to ${result.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Download has failed to save due to system error. Please try again.');
            }

            handleCancel();
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleCancel = () => {
        resetForm();

        mainContext.HandleAddDownload(false);
    };

    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType, errorMessage);
    }

    const resetForm = () => {
        setDownloadData({
            startdate: '',
            enddate: '',
            freqtype: '',
            vesselid: '',
            deviceid: ''
        });

        setValidationErrors({
            startdate: '',
            enddate: '',
            freqtype: '',
            vesselid: '',
            deviceid: ''
        });

        setSelectedOpt({
            freqtype: '',
            vesselid: '',
            deviceid: ''
        });

        setSelectedDesc({
            freqtype: '',
            vesselid: '',
            deviceid: ''
        });

        setShowDropdown({
            freqtype: false,
            vesselid: false,
            deviceid: false
        });

        setDevices([]);
    }

    const handleStartDateChange = (date) => {
        //console.log('handleStartDateChange',date)
        setSelectedStartDate(date);
        setSelectedEndDate(date);

        setDownloadData((prev) => ({
            ...prev,
            startdate: date,
            enddate: date,
        }));

        setValidationErrors((prev) => ({
            ...prev,
            startdate: '',
            enddate: ''
        }));
    };

    const handleEndDateChange = (date) => {
        setSelectedEndDate(date);

        setDownloadData((prev) => ({
            ...prev,
            enddate: date,
        }));

        setValidationErrors((prev) => ({
            ...prev,
            enddate: '',
        }));
    };

    const getMinEndDate = () => {
        if (!selectedStartDate) return null;
        var dt = convertToDate(selectedStartDate);
        //console.log(new Date(dt.getTime()));
        return new Date(dt.getTime());
    };

    const getMaxEndDate = () => {
        if (!selectedStartDate) return null;
        var dt = convertToDate(selectedStartDate);
        //console.log(new Date(dt.getTime() + (60 * 60 * 1000)));
        return new Date(dt.getTime() + (60 * 60 * 1000)); // Add 1 hour
    };

    const convertToDate = (value) => {
        // If the value is already a Date object, return it. If it's a string, try to convert it.
        if (value instanceof Date && !isNaN(value)) {
            return value;
        } else if (typeof value === 'string') {
            const date = new Date(value);
            return isNaN(date.getTime()) ? null : date; // Return null if date is invalid
        }
        return null;
    };

    const getVessels = async () => {
        const result = await VesselServices.GetVessels();
        if (!!result) {
            setVessels(result.data);
        }
    };

    const getDevicesByVesselId = async (vesselid) => {
        const result = await DeviceServices.GetDevicesByVesselId(vesselid);
        if (!!result) {
            setDevices(result.data);

            setDownloadData((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setValidationErrors((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                deviceid: ''
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                deviceid: ''
            }));

            setShowDropdown((prev) => ({
                ...prev,
                deviceid: false
            }));

        }
    };

    useEffect(() => {
        async function fetchData(vesselid) {
            await getDevicesByVesselId(vesselid);
        }
        if (selectedOpt.vesselid) {
            //Get device lists
            fetchData(selectedOpt.vesselid);
        }
    }, [selectedOpt.vesselid]);

    useEffect(() => {
        async function fetchData() {
            await getVessels();
        }

        if (mainContext.ShowAddDownload) {
            //Get vessel lists
            fetchData();

            //Convert current datetime to UTC
            const currentStartDate = new Date();
            const currentUTCStartDate = new Date(currentStartDate.getTime()); //reset back into utcdate
            setSelectedStartDate(currentUTCStartDate);

            //Convert current datetime to UTC
            const currentEndDate = new Date();
            const currentUTCEndDate = new Date(currentEndDate.getTime()); //reset back into utcdate
            setSelectedEndDate(currentUTCEndDate);

            setDownloadData((prev) => ({
                ...prev,
                startdate: currentUTCStartDate,
                enddate: currentUTCEndDate
            }));
        }

    }, [mainContext.ShowAddDownload]);

    return (
        <>
            <div className={`dialog-overlay ${mainContext.ShowAddDownload ? '' : 'hidden'}`}>
                <div className="dialog-container dialog-container-long">
                    <button className="dialog-close-button" onClick={handleCancel} >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                    <p className="dialog-title col-rps-light mt-0 mb-0">New Download</p>
                    <div className="dialog-content">
                        <div className="mb-2">
                            <div className="position-relative d-flex align-items-center input-label-group">
                                <label htmlFor="ddlFreqType" className="w-30 required">Frequency Type</label>
                                <button id="ddlFreqType" className={`btn-dropdown w-70 ${validationErrors.freqtype ? 'dropdown-error' : ''} ${showDropdown.freqtype ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownFreqType}>
                                    <span id="ddlSelectedOptFreqType" className="btn-dropdown-text float-left">{selectedDesc.freqtype}</span>
                                    <span className={`btn-dropdown-direction float-right ${showDropdown.freqtype ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                </button>
                                <div className={`dropdown-content dropdown-content-freqtype-link ${showDropdown.freqtype ? 'd-block' : 'd-none'}`}>
                                    <div className={`dropdown-content-link ${isOptionSelected('0', 'freqtype')}`} onClick={() => handleOptionClick('0', 'Low', 'freqtype')}><span>Low</span>{renderSelectTag('1', 'freqtype')}</div>
                                    <div className={`dropdown-content-link ${isOptionSelected('1', 'freqtype')}`} onClick={() => handleOptionClick('1', 'Mid', 'freqtype')}><span>Mid</span>{renderSelectTag('2', 'freqtype')}</div>
                                </div>
                            </div>
                            {validationErrors.freqtype && (
                                <label className="error error-message">
                                    <i className="fa-solid fa-circle-info"></i> {validationErrors.freqtype}
                                </label>
                            )}
                        </div>
                        <div className="mb-2">
                            <div className="position-relative d-flex align-items-center input-label-group">
                                <label htmlFor="ddlVesselId" className="w-30 required">Vessel</label>
                                <button id="ddlVesselId" className={`btn-dropdown w-70 ${validationErrors.vesselid ? 'dropdown-error' : ''} ${showDropdown.vesselid ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownVesselId}>
                                    <span id="ddlSelectedOptVesselId" className="btn-dropdown-text float-left">{selectedDesc.vesselid}</span>
                                    <span className={`btn-dropdown-direction float-right ${showDropdown.vesselid ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                </button>
                                <div className={`dropdown-content dropdown-content-vessel-link ${showDropdown.vesselid ? 'd-block' : 'd-none'}`}>
                                    {vessels.map(option => (
                                        <div key={`vesselid-${option.vesselid}`} className={`dropdown-content-link ${isOptionSelected(option.vesselid, 'vesselid')}`} onClick={() => handleOptionClick(option.vesselid, option.vesselname, 'vesselid')}><span>{option.vesselname}</span>{renderSelectTag(option.vesselid, 'vesselid')}</div>
                                    ))}
                                </div>
                            </div>
                            {validationErrors.vesselid && (
                                <label className="error error-message">
                                    <i className="fa-solid fa-circle-info"></i> {validationErrors.vesselid}
                                </label>
                            )}
                        </div>
                        <div className="mb-2">
                            <div className="position-relative d-flex align-items-center input-label-group">
                                <label htmlFor="ddlDeviceId" className="w-30 required">Device</label>
                                <button id="ddlDeviceId" disabled={!(devices && devices.length > 0)} className={`btn-dropdown w-70 ${validationErrors.deviceid ? 'dropdown-error' : ''} ${showDropdown.deviceid ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownDeviceId}>
                                    <span id="ddlSelectedOptDeviceId" className="btn-dropdown-text float-left">{selectedDesc.deviceid}</span>
                                    <span className={`btn-dropdown-direction float-right ${showDropdown.deviceid ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                </button>
                                <div className={`dropdown-content dropdown-content-device-link ${showDropdown.deviceid ? 'd-block' : 'd-none'}`}>
                                     {devices.map(option => (
                                        <div key={`deviceid-${option.deviceid}`} 
                                            className={`dropdown-content-link ${isOptionSelected(option.deviceid, 'deviceid')} ${(!option.containername || option.containername.trim() === '') ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (option.containername && option.containername.trim() !== '') {
                                                    handleOptionClick(option.deviceid, option.devicename, 'deviceid');
                                                }
                                            }}
                                        >
                                            <span>{option.devicename}</span>
                                            {(!option.containername || option.containername.trim() === '') && (
                                                <span className="tooltip-text">No storage container linked.</span>
                                            )}
                                            {renderSelectTag(option.deviceid, 'deviceid')}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {validationErrors.deviceid && (
                                <label className="error error-message">
                                    <i className="fa-solid fa-circle-info"></i> {validationErrors.deviceid}
                                </label>
                            )}
                        </div>
                        <div className="mb-2">
                            <div className="d-flex align-items-center input-label-group input-label-group-date">
                                <label className="w-30 required">Start Date (UTC)</label>
                                <div className="react-datepicker-wrapper-section w-70">
                                    <Calendar
                                        value={selectedStartDate}
                                        onChange={handleStartDateChange}
                                        required={true}
                                        readonly={false}
                                    />
                                </div>
                            </div>
                            {validationErrors.startdate && (
                                <label className="error error-message">
                                    <i className="fa-solid fa-circle-info"></i> {validationErrors.startdate}
                                </label>
                            )}
                        </div>
                        <div className="mb-2">
                            <div className="d-flex align-items-center input-label-group input-label-group-date">
                                <label className="w-30 required">End Date (UTC)</label>
                                <div className="react-datepicker-wrapper-section w-70">
                                    <Calendar
                                        value={selectedEndDate}
                                        onChange={handleEndDateChange}
                                        required={true}
                                        readonly={false}
                                        minDate={selectedStartDate}       // Set minDate as the start date
                                        maxDate={selectedStartDate}       // Set maxDate to the same day as start date
                                        minTime={getMinEndDate()}           // Set minTime as start time
                                        maxTime={getMaxEndDate()}         // Set maxTime to 1 hour after start time
                                    />
                                </div>
                            </div>
                            {validationErrors.enddate && (
                                <label className="error error-message">
                                    <i className="fa-solid fa-circle-info"></i> {validationErrors.enddate}
                                </label>
                            )}
                        </div>
                    </div>
                    <div className="dialog-buttons float-right">
                        <button id="btnSaveDownload" className="btn btn-dialog btn-primary btn-me" onClick={handleSaveDownload}>Save</button>
                        <button className="btn btn-dialog btn-secondary" onClick={handleCancel}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewDownload;
